import get from 'lodash/get';
import * as authorAllFeedActions from '../../action_creators/author/author_all_feed_action_creators';
import AuthorAllFeedModel from '../../../models/author/author_all_feed';
import log from '../../../services/logger_service';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';

export default function fetchAuthorAllFeed(params, store) {
  return function authorAllFeed(dispatch) {
    dispatch(authorAllFeedActions.authorAllFeedLoading());
    return AuthorAllFeedModel.fetch(params, store)
      .then(function handleAuthorAllFeedData(authorAllFeedData) {
        if (params.page && !get(authorAllFeedData, 'data.posts.length')) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        }
        dispatch(
          authorAllFeedActions.authorAllFeedLoaded(
            authorAllFeedData.data,
            store
          )
        );
      })
      .catch(function handleAuthorAllFeedError(err) {
        dispatch(authorAllFeedActions.authorAllFeedLoadError(err, store));
        log.error(
          err,
          `Error in all author all feed actions, message: ${err.message}`
        );
      });
  };
}
